import PropTypes from 'prop-types';
import React from 'react';

const SingleCheckboxField = ({
  customFieldValue,
  index,
  singleCheckBoxFieldChanged,
  disabled
}) => (
  <div className="form-group" style={{ padding: '10px 20px' }}>
    <input type="hidden"
           name={"task_completion[custom_field_values_attributes][" + index + "][type]"}
           value={"CustomFieldValues::Checkbox"} />
    <div key={index} className="custom-control custom-checkbox">
      <input
        type="checkbox"
        className="custom-control-input"
        disabled={disabled}
        name={`task_completion[custom_field_values_attributes][${index}][value]`}
        value={customFieldValue.value || "0"}
        checked={customFieldValue.value === "1"}
        onChange={(e) => singleCheckBoxFieldChanged(index, e.target.checked)}
        id={`custom-field-option-${index}`}
      />
      <label
        className="custom-control-label"
        htmlFor={`custom-field-option-${index}`}
      >
        <span>{customFieldValue.custom_field.name}&nbsp;</span>
        {customFieldValue.custom_field.required && (
          <abbr title="required">*</abbr>
        )}
      </label>
    </div>
  </div>
);

SingleCheckboxField.propTypes = {
  customFieldValue: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  singleCheckBoxFieldChanged: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

export default SingleCheckboxField;
